import { render, staticRenderFns } from "./Comparation.vue?vue&type=template&id=84b8d616&scoped=true&"
import script from "./Comparation.vue?vue&type=script&lang=js&"
export * from "./Comparation.vue?vue&type=script&lang=js&"
import style0 from "./Comparation.vue?vue&type=style&index=0&id=84b8d616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b8d616",
  null
  
)

export default component.exports